(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["abs-card-shipping-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('abs-card-shipping')) {
    const quotes = new Map();
    const queue = [];
    let running = 0;
    const pump = () => {
      while (running < 2 && queue.length) {
        const job = queue.shift();
        running += 1;
        Promise.resolve().then(job.task).then(job.resolve, job.reject).finally(() => {
          running -= 1;
          pump();
        });
      }
    };
    const enqueue = task => new Promise((resolve, reject) => {
      queue.push({ task, resolve, reject });
      pump();
    });
    const validateRates = data => {
      if (!Array.isArray(data.rates) || !data.rates.length) throw new Error('No rates');
      const currency = data.rates[0].currency;
      if (!/^[A-Z]{3}$/.test(currency)) throw new Error('Invalid currency');
      for (const rate of data.rates) {
        if (rate.currency !== currency || !Number.isSafeInteger(rate.total_price) || rate.total_price < 0) {
          throw new Error('Invalid rate');
        }
      }
      const amount = Math.min(...data.rates.map(rate => rate.total_price));
      return { amount, currency, from: data.rates.some(rate => rate.total_price !== amount) };
    };
    const quoteFor = dataset => {
      const key = JSON.stringify([dataset.endpoint, dataset.handle, dataset.variantId, dataset.country]);
      const existing = quotes.get(key);
      if (existing && existing.expires > Date.now()) return existing.promise;
      const entry = { expires: Date.now() + 300000 };
      entry.promise = enqueue(async () => {
        const endpoint = new URL(dataset.endpoint);
        if (endpoint.protocol !== 'https:') throw new Error('HTTPS required');
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'omit',
            signal: controller.signal,
            body: JSON.stringify({
              productHandle: dataset.handle,
              variantId: String(dataset.variantId),
              quantity: 1,
              country: dataset.country
            })
          });
          if (!response.ok) throw new Error('Unavailable');
          return validateRates(await response.json());
        } finally {
          clearTimeout(timer);
        }
      });
      quotes.set(key, entry);
      entry.promise.catch(() => {
        entry.expires = Date.now() + 30000;
      });
      return entry.promise;
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          entry.target.loadQuote();
        }
      }
    }, { rootMargin: '100px 0px' }) : null;
    customElements.define('abs-card-shipping', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded || this.loading) return;
        if (observer) observer.observe(this);
        else this.loadQuote();
      }
      disconnectedCallback() {
        observer?.unobserve(this);
      }
      formatAmount(quote) {
        const currency = this.dataset.currency;
        if (!/^[A-Z]{3}$/.test(currency)) throw new Error('Invalid currency');
        let amount = quote.amount / 100;
        if (quote.currency !== currency && quote.amount !== 0) {
          const current = window.Shopify?.currency;
          const rate = Number(current?.rate);
          if (quote.currency !== this.dataset.shopCurrency || current?.active !== currency
              || !Number.isFinite(rate) || rate <= 0) throw new Error('No exchange rate');
          amount *= rate;
        }
        if (!Number.isFinite(amount) || amount < 0 || amount > Number.MAX_SAFE_INTEGER / 100) {
          throw new Error('Invalid amount');
        }
        return new Intl.NumberFormat(document.documentElement.lang || 'de', {
          style: 'currency', currency, currencyDisplay: 'narrowSymbol'
        }).format(amount);
      }
      async loadQuote() {
        if (!this.isConnected || this.loaded || this.loading) return;
        this.loading = true;
        try {
          const quote = await quoteFor(this.dataset);
          const formatted = this.formatAmount(quote);
          const target = this.querySelector('[data-card-shipping-price]');
          if (target) target.textContent = ': ' + (quote.from ? this.dataset.from + ' ' : '') + formatted;
          this.loaded = true;
        } catch (_) {
          this.loaded = false;
        } finally {
          this.loading = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["abs-shipping-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('abs-shipping-quote')) {
    customElements.define('abs-shipping-quote', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const opts = { signal: this.lifecycle.signal };
        this.status = this.querySelector('[data-status]');
        this.price = this.querySelector('[data-price]');
        this.variantId = this.dataset.variantId;
        this.scope = this.closest('.shopify-section');
        this.scope?.addEventListener('on:variant:change', e => {
          if (e.detail?.form?.getAttribute('id') !== this.dataset.formId) return;
          this.variantId = e.detail.variant?.id || '';
          this.schedule();
        }, opts);
        const quantityChanged = e => {
          if (e.target.name === 'quantity' && e.target.form?.getAttribute('id') === this.dataset.formId) this.schedule();
        };
        this.scope?.addEventListener('input', quantityChanged, opts);
        this.scope?.addEventListener('change', quantityChanged, opts);
        this.schedule();
      }
      disconnectedCallback() {
        this.sequence = (this.sequence || 0) + 1;
        this.lifecycle?.abort(); this.pending?.abort(); clearTimeout(this.timer);
      }
      invalidate() {
        this.sequence = (this.sequence || 0) + 1;
        this.pending?.abort();
        this.price.textContent = '—';
        this.status.textContent = this.dataset.endpoint ? '' : this.dataset.preview;
      }
      schedule() {
        clearTimeout(this.timer); this.invalidate();
        if (this.dataset.endpoint) this.timer = setTimeout(() => this.calculate(), 350);
      }
      formatAmount(amount, sourceCurrency) {
        const currency = this.dataset.currency;
        if (!/^[A-Z]{3}$/.test(currency)) throw new Error('Invalid currency');
        let converted = amount / 100;
        if (sourceCurrency !== currency && amount !== 0) {
          const current = window.Shopify?.currency;
          const rate = Number(current?.rate);
          if (sourceCurrency !== this.dataset.shopCurrency || current?.active !== currency
              || !Number.isFinite(rate) || rate <= 0) throw new Error('Currency conversion unavailable');
          converted *= rate;
        }
        if (!Number.isFinite(converted) || converted < 0 || converted > Number.MAX_SAFE_INTEGER / 100) {
          throw new Error('Invalid converted amount');
        }
        return new Intl.NumberFormat(document.documentElement.lang || 'de', {
          style: 'currency', currency, currencyDisplay: 'narrowSymbol'
        }).format(converted);
      }
      async calculate() {
        const form = document.getElementById(this.dataset.formId);
        const variantId = form?.elements.namedItem('id')?.value || this.variantId;
        const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
        if (!variantId || !this.variantId || !Number.isInteger(quantity) || quantity < 1) {
          this.status.textContent = this.dataset.choose; return;
        }
        const sequence = this.sequence;
        const controller = new AbortController();
        this.pending = controller;
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const url = new URL(this.dataset.endpoint);
          if (url.protocol !== 'https:') throw new Error('HTTPS required');
          const response = await fetch(url, {
            method:'POST', headers:{'Content-Type':'application/json'}, credentials:'omit',
            signal:controller.signal,
            body:JSON.stringify({ productHandle:this.dataset.handle, variantId:String(variantId), quantity, country:this.dataset.country })
          });
          if (!response.ok) throw new Error('Unavailable');
          const data = await response.json();
          if (sequence !== this.sequence || !this.isConnected) return;
          if (!Array.isArray(data.rates)) throw new Error('Invalid response');
          if (!data.rates.length) { this.status.textContent = this.dataset.unavailable; return; }
          const currencies = new Set();
          data.rates.forEach(rate => {
            if (!Number.isSafeInteger(rate.total_price) || rate.total_price < 0 || !/^[A-Z]{3}$/.test(rate.currency)) throw new Error('Invalid rate');
            currencies.add(rate.currency);
          });
          if (currencies.size !== 1) throw new Error('Mixed currencies');
          const amount = Math.min(...data.rates.map(rate => rate.total_price));
          const differentAmounts = data.rates.some(rate => rate.total_price !== amount);
          const formatted = this.formatAmount(amount, data.rates[0].currency);
          this.price.textContent = (differentAmounts ? this.dataset.from + ' ' : '') + formatted;
          this.status.textContent = '';
        } catch (_) {
          if (sequence === this.sequence && this.isConnected) this.status.textContent = this.dataset.error;
        } finally { clearTimeout(timeout); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["abs-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
  const link = document.getElementById('abs-whatsapp');
  const proxy = document.getElementById('abs-live-chat');
  const email = document.getElementById('abs-email');
  if (!link || !proxy) return;
  proxy.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    const runtime = root?.querySelector('shopify-agent-runtime');
    const activator = runtime?.shadowRoot?.querySelector('button.activator') || root?.querySelector('button.activator');
    if (runtime) {
      runtime.setAttribute('open', '');
    } else if (activator?.isConnected) {
      activator.click();
    }
  });
  const observed = new WeakSet();
  const measured = new WeakSet();
  let pending = false;
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  function observeRoot(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);
    const style = document.createElement('style');
    style.textContent = '.activator{visibility:hidden!important;pointer-events:none!important}:host{position:fixed!important;inset:0!important;transform:none!important;translate:none!important;scale:1!important;transition:none!important;animation:none!important;contain:none!important}#shopify-element-wrapper{transform:none!important;translate:none!important;transition:none!important;animation:none!important;contain:none!important}.activator__label,.activator__icon{color:#000!important;-webkit-text-fill-color:#000!important}.activator{--activator-fg:#000!important;--activator-bg:#fff!important}.activator-nudge{position:static!important;transform:none!important;translate:none!important;animation:none!important;transition:none!important}.activator{position:fixed!important;top:auto!important;left:auto!important;right:var(--abs-contact-right,20px)!important;bottom:var(--abs-contact-bottom,24px)!important;background:#fff!important;color:#000!important;border:0!important;border-radius:12px!important;box-shadow:0 0 14px rgb(0 0 0 / .5)!important;transform:none!important;translate:none!important;scale:1!important;animation:none!important;transition:background-color .15s!important;min-height:50px!important}.activator:hover{background:#f5f5f5!important}';
    root.appendChild(style);
    new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['open','aria-expanded']});
  }
  function update() {
    pending = false;
    const host = document.querySelector('shopify-chat');
    observeRoot(host?.shadowRoot);
    const runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime');
    observeRoot(runtime?.shadowRoot);
    const button = host?.shadowRoot?.querySelector('button.activator') || runtime?.shadowRoot?.querySelector('button.activator');
    link.hidden = Boolean(runtime?.hasAttribute('open') || button?.getAttribute('aria-expanded') === 'true');
    proxy.hidden = link.hidden || !button;
    if (email) email.hidden = link.hidden;
    if (!button) return;
    const label = button.getAttribute('aria-label') || button.textContent.trim();
    proxy.setAttribute('aria-label',label);
    const caption = proxy.querySelector('span');
    if (caption.textContent !== label) caption.textContent = label;
    if (!measured.has(button)) {
      measured.add(button);
      new ResizeObserver(schedule).observe(button);
    }
    if (proxy.offsetWidth) document.documentElement.style.setProperty('--abs-chat-width',proxy.offsetWidth + 'px');
    link.style.fontFamily = getComputedStyle(button).fontFamily;
    proxy.style.fontFamily = getComputedStyle(button).fontFamily;
  }
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  addEventListener('resize',schedule,{passive:true});
  schedule();
  setTimeout(schedule,1000);
  setTimeout(schedule,3000);
  setTimeout(schedule,8000);
})();
  } catch(e) { console.error(e); }
})();

})();
